import { ReactNode, ReactElement } from 'react';
import t from 'react-translate';

import { css } from '@emotion/react';
import { gray5 } from 'styles/global_defaults/colors';
import { quarterSpacing } from 'styles/global_defaults/scaffolding';

import { Button } from 'react-bootstrap';
import NvIcon from 'shared/components/nv-icon';
import NvPopover from 'shared/components/nv-popover';
import ClickableContainer from 'components/clickable-container';

const dataDownloadCardStyles = css`
  border-radius: ${quarterSpacing}px;
  border: 1px solid ${gray5};

  .svg-container {
    height: fit-content;
  }
`;

export type DataDownloadCardProps = {
  title: string;
  description: string;
  downloadUrl: string;
  ariaLabel: string;
  dataQa: string;
  graphic: ReactNode;
  popoverContent: ReactElement;
};

const DataDownloadCard = ({
  title,
  description,
  downloadUrl,
  ariaLabel,
  dataQa,
  graphic,
  popoverContent,
}: DataDownloadCardProps) => (
  <div css={dataDownloadCardStyles} className='download-card d-flex flex-column p-2'>
    <div className='d-flex justify-content-between align-items-center m-2'>
      <div className='font-weight-bold mr-4'>{title}</div>
      <Button
        variant='secondary'
        className='d-flex align-items-center'
        href={downloadUrl}
        target='_blank'
        aria-label={ariaLabel}
        data-qa={dataQa}
      >
        <NvIcon icon='download' size='smallest' className='mr-1' />
        {t.MENTORING_PROGRAMS.REPORTING.DOWNLOAD()}
      </Button>
    </div>
    <div className='d-flex flex-grow-1 justify-content-between'>
      <div className='d-flex flex-column justify-content-between m-2'>
        <div className='text-body gray-2'>{description}</div>
        <div className='d-flex font-weight-bold text-small mt-4'>
          {t.MENTORING_PROGRAMS.REPORTING.WHATS_INCLUDED()}
          <NvPopover
            showOnHover
            placement='top'
            content={popoverContent}
          >
            <ClickableContainer aria-label={t.MENTORING_PROGRAMS.REPORTING.WHATS_INCLUDED()}>
              <NvIcon icon='info' size='smallest' className='gray-3 ml-1' />
            </ClickableContainer>
          </NvPopover>
        </div>
      </div>
      <div className='svg-container my-auto'>
        {graphic}
      </div>
    </div>
  </div>
);

export default DataDownloadCard;
